import * as React from 'react';
import axios, { CancelTokenStatic } from 'axios';
import clsx from 'clsx';
import { useHistory } from "react-router-dom";
import { makeStyles, useMediaQuery } from '@material-ui/core';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { ElementDimensions } from '../../styles/ElementDimensions';
import { CheckState, CheckStateContext } from '../../providers/CheckStateContextProvider';
import {useStripe} from '@stripe/react-stripe-js';
import ErrorDialog, { ErrorDialogProps } from '../common/ErrorDialog';
import { StripePaymentCompleteRequest } from '../../models/payment/StripePaymentCompleteRequest';
import { StripePaymentDetail } from '../../models/payment/StripePaymentDetail';
import { MakePaymentResponse } from '../../models/payment/MakePaymentResponse';
import { loadStripe, PaymentIntent } from '@stripe/stripe-js';
import { String_PayCheck_ErrorPaymentFailed, String_System_ConnectionError, String_System_GeneralError } from '../../utilities/StringHelper';
import { SplitType } from '../../models/common/SplitType';
import Loader from '../common/Loader';

const useStyles = makeStyles({
    root: {
        textAlign: 'center',
        height: 'calc(100vh - ' + (73 + ElementDimensions.appBarHeight + ElementDimensions.stepperHeight + ElementDimensions.footerBarHeightPaymentScreen) + 'px)',
    },
    rootLandscape: {
        textAlign: 'center',
        height: '150%',
    },
});

export interface StripePaymentCompleteProps {
    clientSecret: string,
}

export default function StripePaymentComplete(props: StripePaymentCompleteProps) {
    const { clientSecret } = props;
    const isPortrait = true;
    let history = useHistory();
    const [errorDialogOpen, setErrorDialogOpen] = React.useState<boolean>(false);
    const [errorMessage, setErrorMessage] = React.useState<string>('');    
    const [loaded, setLoaded] = React.useState<boolean>(false);
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const checkState = React.useContext(CheckStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const stripe = useStripe();
  
    React.useEffect(() => {
        
        if (!stripe) {
            return;
        }
        
        stripe!!
        .retrievePaymentIntent(clientSecret!!)
        .then(({paymentIntent}) => {
            if (paymentIntent !== undefined) {
                switch (paymentIntent.status) {
                    case 'succeeded':
                        const CancelToken = axios.CancelToken;
                        const source = CancelToken.source();
    
                        notifyPaymentComplete(paymentIntent, CancelToken);
                        break;
                    default:
                        setLoaded(true);                
                        setErrorMessage(String_PayCheck_ErrorPaymentFailed.find(s => s.key === userState.state.locale)!!.value);
                        setErrorDialogOpen(true);
                    break;
                }
            }
            else {
                setErrorMessage(String_PayCheck_ErrorPaymentFailed.find(s => s.key === userState.state.locale)!!.value);
                setErrorDialogOpen(true);
            }
        });

    }, [stripe]);

    const notifyPaymentComplete = (paymentIntent: PaymentIntent, cancelToken: CancelTokenStatic) => {
        if (paymentIntent !== null) {
            const paymentDetail: StripePaymentDetail = {
                tip: checkState.state.tip,
                tax: checkState.state.checkTotal!!.tax,
                total: checkState.state.checkTotal!!.total,
                sub_total: checkState.state.checkTotal!!.sub_total,
                amount_to_pay: checkState.state.checkTotal!!.amount_due
            }
    
            const request: StripePaymentCompleteRequest = {
                user_id: userState.state.userId!!,
                check_please_payment_id: checkState.state.paymentId!!,
                payment_detail: paymentDetail,                            
            };
    
            axios.post(process.env.REACT_APP_CHECKOUT_API_URL + '/payment/stripecomplete/', request, { cancelToken: cancelToken.source().token })
            .then(function(response) {
                let r = response.data as MakePaymentResponse;

                if (r.success === true) {
                    handlePaymentComplete(r);
                }
                else {
                    setLoaded(true);
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                    setErrorDialogOpen(true);
                }
            })
            .catch(function(error) {
                setLoaded(true);
                if (error.response) {
                    setErrorMessage(String_System_GeneralError.find(s => s.key === userState.state.locale)!!.value);
                }
                else {
                    setErrorMessage(String_System_ConnectionError.find(s => s.key === userState.state.locale)!!.value);
                }

                setErrorDialogOpen(true);
            });
        }
    };

    const handlePaymentComplete = (r: MakePaymentResponse) => {
        const state: CheckState = checkState.state;
        state.checkSummary = null;
        state.checkDetail = null;
        state.checkTotal = null;
        state.paymentId = null;
        state.splitType = SplitType.None;
        state.splitPercentage = 0;
        state.splitAmount = 0;
        state.splitEvenlyCount = 0;
        state.checkTotalWithTip = '';
        state.tip = 0;
        state.tipString = '';
        checkState.setState(state);

        history.push({
            pathname: '/postcheckout/review',
            state: { 
                paymentId: r.check_please_payment_id,
            }
        });
    }

    const NavigateCheckOutStart = () => {
        throw new Error('Function not implemented.');
    }
    

    const handleErrorDialogClose = (event: React.MouseEvent<HTMLElement>) => {
        setErrorDialogOpen(false);
        NavigateCheckOutStart();
    }

    const errorDialogProps: ErrorDialogProps = {
        open: errorDialogOpen,
        message: errorMessage,
        tryAgain: false,
        onCloseHandler: handleErrorDialogClose,
    }

    return (
        <div className={clsx({
            [classes.root]: isPortrait,
            [classes.rootLandscape]: !isPortrait,
        })}>

            {!loaded &&
                <Loader />                    
            }

            <ErrorDialog
                open={errorDialogProps.open}
                message={errorDialogProps.message}
                tryAgain={errorDialogProps.tryAgain}
                onCloseHandler={errorDialogProps.onCloseHandler} />
        </div>
        
    );
}

